import { useContext, useEffect, useState } from "react"
import { Route, Switch, useHistory } from 'react-router-dom/cjs/react-router-dom'
import { IoArrowBackCircle } from "react-icons/io5";
import { Table } from "rsuite";

import CommonContainer from "../CommonContainer"
import Task from "./task";
import Emails from "./email";
import Notification from "./notification";
import { colors } from "../../utils/constants/colors";
import RejectedSupplierDetail from "./notification/NotificationList/Details/RejectedSupplier";
import MissedCallDetail from "./notification/NotificationList/Details/MissedCall";
import { CONSTANTS } from "../../utils/constants/constants";
import EmailDetail from "./notification/NotificationList/Details/Email";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { AppContext } from "../../context";

const { Cell } = Table

export const TableCell = ({ rowData, dataKey, selectedMailAndCategory, onPageChange, type = 'string', ...props }) => {
    let sender = ''
    let date = ''

    if (dataKey === 'sender') {
        if (selectedMailAndCategory?.category === "sent") {
            sender = rowData?.receiverEmail
        } else if (selectedMailAndCategory?.category === "inbox" || selectedMailAndCategory?.category === "junk") {
            sender = rowData?.senderEmail
        }

        return (
            <Cell {...props} className="table-link" onClick={() => { onPageChange(rowData?.messageId) }}>
                <p>{sender}</p>
            </Cell>
        )
    } else if (dataKey === "bodyPreview") {
        if (selectedMailAndCategory?.category === 'drafts') {
            return (
                <Cell {...props} className="table-link" onClick={() => { onPageChange(rowData?.messageId) }}>
                    <p >{rowData?.body}</p>
                </Cell>
            )
        } else {
            return (
                <Cell {...props} className="table-link" onClick={() => { onPageChange(rowData?.messageId) }}>
                    <p >{rowData?.subject}</p>
                </Cell>
            )
        }


    } else if (dataKey === "date") {
        if (selectedMailAndCategory?.category === 'sent') {
            date = rowData?.sentDate
        } else {
            date = rowData?.receivedDate
        }

        return (
            <Cell {...props} className="table-link" onClick={() => { onPageChange(rowData?.messageId) }}>
                <p >{date}</p>
            </Cell>
        )
    }
}

const Tasks = () => {
    const history = useHistory()
    const location = useLocation()
    const [tab, setTab] = useState(CONSTANTS.TASK_TABS.EMAILS)   // email, task, notification
    const [subTab, setSubTab] = useState(CONSTANTS.NOTI_SUB_TABS.EMAILS) // email, voicemail, missed call, 
    const [currentPage, setCurrentPage] = useState('') // inbox, sent, draft, emailDetails, draftEmail, notificationDetail
    const { setNotificationCheckbox } = useContext(AppContext);

    const onChangeTab = (currentTab) => {
        history.push(`/tasks/${currentTab}`)
        if (currentTab === CONSTANTS.TASK_TABS.EMAILS) {
            setTab(CONSTANTS.TASK_TABS.EMAILS)
            setCurrentPage('')
        } else if (currentTab === CONSTANTS.TASK_TABS.TASKS) {
            setTab(CONSTANTS.TASK_TABS.TASKS)
            setCurrentPage('')
        } else if (currentTab === CONSTANTS.TASK_TABS.NOTIFICATIONS) {
            setTab(CONSTANTS.TASK_TABS.NOTIFICATIONS)
            setCurrentPage('')
        }
        setNotificationCheckbox(false)
    }

    const onGoToEmailHandler = (tab) => {
        if (tab === CONSTANTS.TASK_TABS.EMAILS) {
            history.push('/tasks/emails')
            setTab(CONSTANTS.TASK_TABS.EMAILS)
        } else if (tab === CONSTANTS.TASK_TABS.NOTIFICATIONS) {
            history.push('/tasks/notifications')
            setCurrentPage('')
        }
    }

    useEffect(() => {
        if (window?.location?.pathname.includes('/tasks/notifications/detail')) {
            setTab(CONSTANTS.TASK_TABS.NOTIFICATIONS)
            setCurrentPage(CONSTANTS.NOTI_SUB_TABS.NOTI_DETAIL)
        } else if (window?.location?.pathname.includes('/tasks/notifications')) {
            setTab(CONSTANTS.TASK_TABS.NOTIFICATIONS)
            setCurrentPage('')
        } else if (window?.location?.pathname.includes('/tasks/task')) {
            setTab(CONSTANTS.TASK_TABS.TASKS)
            setCurrentPage('')
        } else if (window?.location?.pathname.includes('/tasks/emails')) {
            setTab(CONSTANTS.TASK_TABS.EMAILS)
            setCurrentPage('')
        }
    }, [])

    useEffect(() => {
        if (location?.state?.subTab) {
            setSubTab(location?.state?.subTab)
        }
    }, [location?.state?.subTab])

    return (
        <CommonContainer>
            <div className="h-100" style={{ backgroundColor: '#fff' }}>
                <div className="d-flex justify-content-between">
                    <h3 className="fw-bold" style={{ color: colors.blue800 }}>Tasks</h3>
                    {tab === CONSTANTS.TASK_TABS.NOTIFICATIONS && currentPage === CONSTANTS.NOTI_SUB_TABS.NOTI_DETAIL && <button className="small_button_success" style={{backgroundColor: "#214466"}} onClick={() => { onGoToEmailHandler('emails') }}>Go To Email</button>}
                </div>
                <div className="d-flex justify-content-between mt-4">
                    <div className="d-flex column-gap-5">
                        <h4
                            style={{
                                color: tab === CONSTANTS.TASK_TABS.EMAILS ? '#214466' : '',
                                borderBottom: tab === CONSTANTS.TASK_TABS.EMAILS ? '4px solid #214466' : '',
                                width: tab === CONSTANTS.TASK_TABS.EMAILS ? 'auto' : '',
                                display: 'inline-block',
                                paddingBottom: tab === CONSTANTS.TASK_TABS.EMAILS ? '5px' : '',
                                cursor: 'pointer'
                            }}
                            className="fw-bold"
                            onClick={() => { onChangeTab(CONSTANTS.TASK_TABS.EMAILS) }}
                        >
                            Email
                        </h4>
                        <h4
                            style={{
                                color: tab === CONSTANTS.TASK_TABS.TASKS ? '#214466' : '',
                                borderBottom: tab === CONSTANTS.TASK_TABS.TASKS ? '4px solid #214466' : '',
                                width: tab === CONSTANTS.TASK_TABS.TASKS ? 'auto' : '',
                                display: 'inline-block',
                                paddingBottom: tab === CONSTANTS.TASK_TABS.TASKS ? '5px' : '',
                                cursor: 'pointer'
                            }}
                            onClick={() => { onChangeTab(CONSTANTS.TASK_TABS.TASKS) }}
                            className="fw-bold"
                        >
                            Tasks
                        </h4>
                        <h4
                            style={{
                                color: tab === CONSTANTS.TASK_TABS.NOTIFICATIONS ? '#214466' : '',
                                borderBottom: tab === CONSTANTS.TASK_TABS.NOTIFICATIONS ? '2px solid #214466' : '',
                                width: tab === CONSTANTS.TASK_TABS.NOTIFICATIONS ? 'auto' : '',
                                display: 'inline-block',
                                paddingBottom: tab === CONSTANTS.TASK_TABS.NOTIFICATIONS ? '5px' : '',
                                cursor: 'pointer'
                            }}
                            onClick={() => { onChangeTab(CONSTANTS.TASK_TABS.NOTIFICATIONS) }}
                            className="fw-bold"
                        >
                            Notifications
                        </h4>
                    </div>
                    {tab === CONSTANTS.TASK_TABS.NOTIFICATIONS && currentPage === CONSTANTS.NOTI_SUB_TABS.NOTI_DETAIL && <button className="rounded-circle" onClick={() => { onGoToEmailHandler('notifications') }}><IoArrowBackCircle color={colors.blue800} size={30} /></button>}
                </div>
                <div className=" mt-4" style={{ height: '85%', borderRadius: '6px' }}>
                    <Switch>
                        <Route path={CONSTANTS.ROUTES.TASKS_NOTIFICATION_REJECTED_SUP_DETAIL_TAB}>
                            <RejectedSupplierDetail
                                tab={tab}
                                setTab={setTab}
                                currentPage={currentPage}
                                setCurrentPage={(setCurrentPage)}
                                subTab={subTab}
                                setSubTab={setSubTab}
                            />
                        </Route>
                        <Route path={CONSTANTS.ROUTES.TASKS_NOTIFICATION_MISSED_CALL_DETAIL_TAB}>
                            <MissedCallDetail
                                tab={tab}
                                setTab={setTab}
                                currentPage={currentPage}
                                setCurrentPage={(setCurrentPage)}
                                subTab={subTab}
                                setSubTab={setSubTab}
                            />
                        </Route>
                        <Route path={CONSTANTS.ROUTES.TASKS_NOTIFICATION_DETAIL_TAB}>
                            <EmailDetail
                                tab={tab}
                                setTab={setTab}
                                currentPage={currentPage}
                                setCurrentPage={(setCurrentPage)}
                                subTab={subTab}
                                setSubTab={setSubTab}
                            />
                        </Route>
                        <Route path={CONSTANTS.ROUTES.TASKS_TASK_TAB}>
                            <Task
                                tab={tab}
                                setTab={setTab}
                                currentPage={currentPage}
                                setCurrentPage={(setCurrentPage)}
                                subTab={subTab}
                                setSubTab={setSubTab}
                            />
                        </Route>
                        <Route path={CONSTANTS.ROUTES.TASKS_NOTIFICATION_TAB}>
                            <Notification
                                tab={tab}
                                setTab={setTab}
                                currentPage={currentPage}
                                setCurrentPage={(setCurrentPage)}
                                subTab={subTab}
                                setSubTab={setSubTab}
                            />
                        </Route>
                        <Route path={CONSTANTS.ROUTES.TASKS_EMAIL_TAB}>
                            <Emails
                                tab={tab}
                                setTab={setTab}
                                currentPage={currentPage}
                                setCurrentPage={(setCurrentPage)}
                                subTab={subTab}
                                setSubTab={setSubTab}
                            />
                        </Route>
                    </Switch>
                </div>

            </div>
        </CommonContainer>
    )
}

export default Tasks